Controller.$inject = [];

function Controller() {
}

export function HuiSeparator() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            height: '@',
            width: '@',
            direction: '@',
            fullHeight: '<',
            fullWidth: '<'
        },
        controller: Controller,
        controllerAs: '$huiSeparatorCtrl',
        template: () => {
            return `
                <div class="hui hui-separator"
                     ng-style="{height : $huiSeparatorCtrl.height + 'px', 
                                width: $huiSeparatorCtrl.width ? $huiSeparatorCtrl.width + 'px' : null}"
                     ng-class="{
                                'horizontal': $huiSeparatorCtrl.direction === 'horizontal',
                                'h-100': $huiSeparatorCtrl.fullHeight && ($huiSeparatorCtrl.direction === 'vertical' || !$huiSeparatorCtrl.direction),
                                'w-100': !$huiSeparatorCtrl.width && $huiSeparatorCtrl.direction === 'horizontal' 
                                }">

                </div>
            `;
        }
    }
}